import { useRef, useState } from "react"
import { useClickOutside } from "../../components/Hooks/useClickOutside"

export default function MobileMenu({ menu }) {
    const [expanded, setExpanded] = useState(false)
    const menuRef = useRef()
    useClickOutside(menuRef, () => { setExpanded(false) })

    const handleDragEnd = (e) => {
        e.preventDefault()

    }
    const handleDragStart = (e) => {
        e.preventDefault()
        setExpanded(!expanded)
    }

    return (<div
        ref={menuRef}
        // draggable
        // onDrag={e => console.log(e)}
        // onDragEnd={handleDragEnd}
        // onDragStart={handleDragStart}

        className={(expanded) ? ' w-100 menu fixed-bottom menu-bg d-xl-none text-center rounded-bottom  rounded-5 text-primary mob-menu open' : ' w-100 menu fixed-bottom menu-bg d-xl-none text-center rounded-bottom  rounded-5 text-primary mob-menu close'} >
        <button
            onTouchStart={handleDragStart}
            onTouchEnd={handleDragEnd}
            onClick={(e) => setExpanded(!expanded)}
            style={{ width: '100%' }}
            className='btn btn-lg text-w-100 text-white'>MENU</button>
        {/* <div className={(this.state.expanded) ? 'h-100 d-block' : 'h-100 d-none'}> */}
        <div>
            <div className='mnu-grid'>
                {menu}
            </div>
        </div>
        <button className='btn btn-lg text-light'></button>
        {/* <button className='btn btn-lg text-light'>MENU</button> */}
    </div>)
}